import LogRocket from 'logrocket';
import { fetchLogin, logout } from 'modules/login/slice/loginSlice';
import { createListenerMiddleware } from '@reduxjs/toolkit';
import getCustomerId from 'services/customerId/getCustomerId';

const logRocketListenerMiddleware = createListenerMiddleware();

logRocketListenerMiddleware.startListening({
  actionCreator: fetchLogin.fulfilled,
  effect: (action, listenerApi) => {
    const userData = action.payload?.data;
    if (userData) {
      const customerId = getCustomerId();
      const uniqueUserId = customerId + '-' + userData.user_id;
      const userIdentity = {
        name: userData.first_name + ' ' + userData.last_name,
        email: userData.email,
        username: userData.username,
        customerId: customerId,
      };
      LogRocket.identify(uniqueUserId, userIdentity);
    }
  },
});

logRocketListenerMiddleware.startListening({
  actionCreator: logout,
  effect: () => {
    LogRocket.startNewSession();
  },
});

export default logRocketListenerMiddleware.middleware;
